export const Limit = Object.freeze({
	ResourcesDialog: 20,
});
export const LimitFeatureId = Object.freeze({
	CalendarIntegration: 'booking_calendar',
	MultiResources: 'booking_multi',
	NotificationsSettings: 'booking_notifications_settings',
	Overbooking: 'booking_overbooking',
	Waitlist: 'booking_waitlist',
});
